module.exports = __webpack_public_path__ + "static/img/14000277.f9d4c74e.png";